import React, { Dispatch, useState } from "react"
import { Modal, Row, Col, Input, message, Radio, Button } from "antd";
import { useParams } from "react-router-dom";
import { createError } from '../../api/errors/errors';
import { getPendingTrayCount, saveExtractedData } from '../../api/trayTable/TrayTableMethods';
import { STATUS } from "../interface/interface"
import { useOlpnContext } from "./OlpnContext"
import { getOlpnCount } from "../../api/OLPN/olpn";

const { TextArea } = Input

const ModalError = (props: {
  modal: boolean, setModal: Dispatch<boolean>, title: string,
  setTitle: Dispatch<string>, setLoading: Dispatch<boolean>,
  data: any, setData: Dispatch<any>, setShowImage: Dispatch<any>, trayId: string | undefined, forced: boolean,
  handleValidate, isRefresh: boolean, setPendingTray: Dispatch<number>
}) => {
  const { modal, setModal, title, setTitle, setLoading, data, setData, setShowImage, trayId, isRefresh } = props
  const [selected, setSelected] = useState<string>("default")
  const [value, setValue] = useState<string>("")
  const { bpId } = useParams()
  const { Olpn } = useOlpnContext()

  const handleOk = async () => {
    if (selected === 'default') {
      return message.warn("Veuillez sélectionner un type de problème")
    }
    setTitle("Mettre en pause le plateau")
    setModal(true)
    const path = sessionStorage.getItem("s3Path")
    const skuList = data.data?.predictions[0]?.Bracelets
    if (bpId) {
      const pending = await getPendingTrayCount(bpId)
      props.setPendingTray(pending.total)
    }
    setLoading(true)
    if (bpId && Olpn && trayId) {
      var elem
      if (!props.forced) {
        renderMessage("Plateau mis en pause", "warning")
        elem = await saveExtractedData(Number(bpId), trayId, path, STATUS.PENDING, skuList, 0, Olpn)
      } else
        elem = await props.handleValidate(undefined, true)
      await createError(elem.trayId, value, selected)
    }
    sessionStorage.setItem("complete", new Date().toISOString())
    sessionStorage.removeItem('error');
    sessionStorage.removeItem("data")
    sessionStorage.removeItem("decodedText")
    setLoading(false)
    setData(undefined)
    setShowImage(undefined)
    setModal(false)
    // if (isRefresh) window.location.reload()
  }

  const renderMessage = (text: string, type: string) => {
    message[type](text)
  }

  const handleCancel = () => {
    setSelected("default")
    setModal(false)
  }

  return (
    <Modal title={title} open={modal}
      footer={[
        <Button onClick={() => handleCancel()}>Annuler</Button>,
        <Button style={{ backgroundColor: "#10b981", color: 'white' }} onClick={() => handleOk()}>Envoyer</Button>
      ]}
      onOk={handleOk} onCancel={handleCancel} width={1000} centered cancelText="Annuler">
      <div>
        <Row>
          <Col xs={24} className='select-col'>
            <h4>Veuillez sélectionner une raison</h4>
            <Radio.Group value={selected} onChange={e => setSelected(e.target.value)} className="select-container" >
              <Radio.Button style={{ marginRight: "0.5rem" }} key={"sku"} value="wrong sku" >SKU incorrect</Radio.Button>
              <Radio.Button style={{ marginRight: "0.5rem" }} key={"count"} value="wrong count">Quantité incorrecte</Radio.Button>
              <Radio.Button style={{ marginRight: "0.5rem" }} key={"lisibility"} value="lisibility">Etiquette non conforme</Radio.Button>
              <Radio.Button style={{ marginRight: "0.5rem" }} key={"end"} value-="bp_end">Fin de BP</Radio.Button>
              <Radio.Button key={"other"} value='other'>Autre</Radio.Button>
            </Radio.Group>
          </Col>
          <Col xs={24} className="comment-title">
            <span >
              Ajouter un commentaire:
            </span>
            <TextArea autoSize={{ minRows: 3, maxRows: 5 }}
              value={value}
              onChange={e => setValue(e.target.value)}
              placeholder="Commentaire"
            />
          </Col>
        </Row>
      </div>
    </Modal>
  )
}

export default ModalError;